import { render, staticRenderFns } from "./OperatingHours.vue?vue&type=template&id=5f5f979a&scoped=true&"
import script from "./OperatingHours.vue?vue&type=script&lang=js&"
export * from "./OperatingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f979a",
  null
  
)

export default component.exports